// Builds one carousel slide from a pc-media-data entry (see snippets/pc-media-slide-data.liquid).
function buildProductCardSlideElement(slide) {
  const slideEl = document.createElement("div");
  slideEl.className = "embla__slide";

  if (slide.type === "image") {
    const img = document.createElement("img");
    img.className = "product-image";
    img.loading = "eager";
    img.setAttribute("fetchpriority", "high");
    img.alt = slide.alt || "";
    img.sizes = "(min-width: 768px) 640px, min(80vw, 500px)";
    img.srcset = slide.srcset || "";
    img.src = slide.src;
    slideEl.appendChild(img);
  } else if (slide.type === "video") {
    const video = document.createElement("video");
    video.className = "product-video lazy-video";
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.preload = "none";
    video.poster = slide.poster || "";
    (slide.sources || []).forEach((source) => {
      const sourceEl = document.createElement("source");
      sourceEl.dataset.src = source.url;
      sourceEl.type = source.mimeType;
      video.appendChild(sourceEl);
    });
    slideEl.appendChild(video);
  }

  return slideEl;
}

// Rebuilds the single carousel from pc-media-data JSON instead of toggling pre-rendered hidden carousels (removed — see product-card.liquid).
function swapProductCardCarouselColor(productCard, selectedColor) {
  const carousel = productCard.querySelector(".variant-carousel");
  if (!carousel || carousel.dataset.color === selectedColor) return;

  const dataScript = productCard.querySelector(
    'script.pc-media-data[type="application/json"]'
  );
  if (!dataScript) return;

  let mediaData;
  try {
    mediaData = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error("Failed to parse pc-media-data:", e);
    return;
  }

  const slides = mediaData[selectedColor];
  if (!slides) return;

  const container = carousel.querySelector(".embla__container");
  if (!container) return;

  container.innerHTML = "";
  slides.forEach((slide) => {
    container.appendChild(buildProductCardSlideElement(slide));
  });

  carousel.dataset.color = selectedColor;

  const scrollbar = carousel.querySelector(".embla__scrollbar");
  if (scrollbar) {
    scrollbar.classList.toggle("hidden", slides.length <= 1);
  }

  // Slide count/content changed — Embla needs to re-scan, not just re-render.
  if (carousel.emblaApi) {
    carousel.emblaApi.reInit();
  }

  window.initializeLazyVideos?.(carousel);
}

function setAtcLoading(button) {
  if (!button) return;
  button.disabled = true;
  button.classList.add("is-loading");
}

function clearAtcLoading(button, keepDisabled = false) {
  if (!button) return;
  button.classList.remove("is-loading");
  button.disabled = keepDisabled;
}

function showToast(message, type = "info") {
  try {
    const container = document.querySelector(".global-toast-container");
    if (!container) {
      console.warn(
        "Toast container not found in DOM. Ensure snippets/global-toast.liquid is rendered."
      );
      return;
    }

    const toast = document.createElement("div");
    toast.className = `global-toast global-toast--${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    setTimeout(() => toast.classList.add("global-toast--visible"), 50);
    setTimeout(() => {
      toast.classList.remove("global-toast--visible");
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  } catch (err) {
    console.warn("Toast error", err);
  }
}

async function updateExistingCartItems(cart) {
  try {
    window.dispatchEvent(
      new CustomEvent("cart:count-update", {
        detail: {
          count: cart.item_count,
        },
      })
    );

    const updatePromises = cart.items.map((item, index) => {
      if (item.properties && item.properties.is_last === "true") {
        const updatedProperties = { ...item.properties };
        updatedProperties.is_last = "false";

        return fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            line: index + 1,
            properties: updatedProperties,
          }),
        });
      }
      return Promise.resolve();
    });

    await Promise.all(updatePromises);
  } catch (error) {
    console.error("Error updating existing cart items:", error);
  }
}

function closeProductOptions(optionContainer, overlay = null) {
  if (!optionContainer) return;

  optionContainer.classList.remove("open");

  if (window.innerWidth < 768 && document.body.style.position === "fixed") {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.overflow = "";
    document.body.style.width = "";
    const scrollPosition = Math.abs(parseInt(scrollY || "0"));
    window.scrollTo(0, scrollPosition);
  }

  if (window.innerWidth < 768 && optionContainer.dataset.originalParent) {
    setTimeout(() => {
      const uniqueId = optionContainer.dataset.uniqueId;

      if (!uniqueId) {
        console.error("No unique ID found on option container");
        return;
      }
      const originalProductOptions = document.querySelector(
        `.product-options[data-product-options-for="${uniqueId}"]`
      );

      if (originalProductOptions) {
        originalProductOptions.appendChild(optionContainer);

        if (!overlay) {
          const relocationDiv = document.getElementById(
            "product-options-relocation"
          );
          overlay = relocationDiv
            ? relocationDiv.querySelector(
              `.product-option-overlay[data-overlay-for="${uniqueId}"]`
            )
            : null;
        }

        if (overlay) {
          originalProductOptions.appendChild(overlay);
        }
      } else {
        console.error(
          `Could not find product-options container for unique ID ${uniqueId}`
        );
      }

      delete optionContainer.dataset.originalParent;
    }, 300);
  }
}

function closeAllProductOptions() {
  const relocationDiv = document.getElementById("product-options-relocation");
  const openContainers = [];

  if (relocationDiv) {
    const relocatedContainer = relocationDiv.querySelector(
      ".product-option-container.open"
    );
    if (relocatedContainer) {
      const overlay = relocationDiv.querySelector(".product-option-overlay");
      openContainers.push({ container: relocatedContainer, overlay });
    }
  }

  document
    .querySelectorAll(".product-option-container.open")
    .forEach((container) => {
      const productOptions = container.closest(".product-options");
      const overlay = productOptions
        ? productOptions.querySelector(".product-option-overlay")
        : null;
      openContainers.push({ container, overlay });
    });

  openContainers.forEach(({ container, overlay }) => {
    closeProductOptions(container, overlay);
  });
}

function openProductOptionsDrawer(productCard) {
  if (!productCard) return;

  const productOptions = productCard.querySelector(".product-options");
  if (!productOptions) return;

  const optionContainer = productOptions.querySelector(
    ".product-option-container"
  );
  const overlay = productOptions.querySelector(".product-option-overlay");
  if (!optionContainer || !overlay) return;

  if (window.innerWidth < 768) {
    const relocationDiv = document.getElementById("product-options-relocation");
    if (relocationDiv) {
      optionContainer.dataset.originalParent = productCard.dataset.productId;
      relocationDiv.appendChild(optionContainer);
      relocationDiv.appendChild(overlay);

      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          optionContainer.classList.add("open");
        });
      });
    }
  } else {
    optionContainer.classList.add("open");
  }
}

function updateDrawerSizesForColor(productCard, product, selectedColor) {
  if (!productCard || !product || !selectedColor) return;

  const colorIdx = product.options.indexOf("Color");
  const sizeButtons = productCard.querySelectorAll(".product-option-button");

  sizeButtons.forEach((btn) => {
    const sizeIdx = product.options.indexOf(btn.dataset.optionName);
    const variant = product.variants.find(
      (v) =>
        v.options[colorIdx] === selectedColor &&
        v.options[sizeIdx] === btn.dataset.optionValue
    );
    const variantOption = btn.closest(".variant-option");

    if (!variant) {
      if (variantOption) variantOption.style.display = "none";
      btn.classList.remove("active");
      return;
    }

    if (variantOption) variantOption.style.display = "";
    btn.dataset.variantId = variant.id;
    btn.dataset.price = variant.price_formatted;
    btn.dataset.comparePrice = variant.compare_at_price_formatted || "";
    btn.classList.toggle("disabled", !variant.available);
    btn.classList.remove("active");
    btn.disabled = !variant.available;

    const notifyButton = variantOption?.querySelector(".notify-me-button");
    if (notifyButton) {
      if (!variant.available) {
        notifyButton.style.display = "";
        notifyButton.setAttribute("onclick", `openNotifyMeModal(${variant.id})`);
      } else {
        notifyButton.style.display = "none";
      }
    }
  });
}

let eventListenersAttached = false;

function attachGlobalEventListeners() {
  if (eventListenersAttached) return;

  document.addEventListener("click", (event) => {
    const closeButton = event.target.closest(".close-product-options-button");
    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();

    const optionContainer = closeButton.closest(".product-option-container");

    if (!optionContainer) return;

    const uniqueId = optionContainer.dataset.uniqueId;
    const relocationDiv = document.getElementById("product-options-relocation");
    const overlay = relocationDiv
      ? relocationDiv.querySelector(
        `.product-option-overlay[data-overlay-for="${uniqueId}"]`
      )
      : null;

    closeProductOptions(optionContainer, overlay);
  });

  document.addEventListener("click", (event) => {
    const overlay = event.target.closest(".product-option-overlay");
    if (!overlay) return;

    event.preventDefault();

    const uniqueId = overlay.dataset.overlayFor;

    if (!uniqueId) return;

    const relocationDiv = document.getElementById("product-options-relocation");
    let optionContainer = relocationDiv
      ? relocationDiv.querySelector(
        `.product-option-container[data-unique-id="${uniqueId}"]`
      )
      : null;

    if (!optionContainer) {
      const productOptions = document.querySelector(
        `.product-options[data-product-options-for="${uniqueId}"]`
      );
      optionContainer = productOptions
        ? productOptions.querySelector(".product-option-container")
        : null;
    }

    if (
      optionContainer &&
      optionContainer.classList.contains("product-option-container")
    ) {
      closeProductOptions(optionContainer, overlay);
    }
  });

  document.addEventListener("click", (event) => {
    if (window.innerWidth < 768) return;

    const clickedContainer = event.target.closest(
      ".product-option-container.open"
    );
    const clickedButton = event.target.closest(".add-to-cart-button");

    if (clickedContainer || clickedButton) return;

    const openContainers = document.querySelectorAll(
      ".product-card .product-option-container.open"
    );

    openContainers.forEach((container) => {
      const productCard = container.closest(".product-card");
      const overlay = productCard
        ? productCard.querySelector(".product-option-overlay")
        : null;
      closeProductOptions(container, overlay);
    });
  });

  // Delegated so N cards cost one listener each, not N; closest() still finds a relocated button.
  document.addEventListener("click", (event) => {
    const button = event.target.closest(".product-option-button");
    if (button) handleVariantButtonClick(button, event);
  });

  document.addEventListener("click", (event) => {
    const swatch = event.target.closest(".pc-swatch");
    if (swatch) handleSwatchClick(swatch, event);
  });

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".add-to-cart-button");
    if (button) handleAddToCartClick(button, event);
  });

  document.addEventListener("click", (event) => {
    const btn = event.target.closest(".pc-atc-view-cart-btn");
    if (btn) handleViewCartClick(btn, event);
  });

  eventListenersAttached = true;
}

let lastProductCardsInitAt = 0;
function initializeProductCards(root = document) {
  // Only the page-wide (root===document) call needs coalescing with cart-drawer's own re-init; a scoped call must always run.
  if (root === document) {
    const now = Date.now();
    if (now - lastProductCardsInitAt < 250) {
      return;
    }
    lastProductCardsInitAt = now;
  }

  // Skip cards still in-flight so their own finally block clears the loading state, not this one.
  root
    .querySelectorAll(".product-card .add-to-cart-button.is-loading")
    .forEach((btn) => {
      const card = btn.closest(".product-card");
      if (!card || card.dataset.atcInFlight !== "true") {
        clearAtcLoading(btn);
      }
    });

  window.observeProductCardCarousels?.();

  attachGlobalEventListeners();

  const productCards = root.querySelectorAll(".product-card");
  productCards.forEach((card) => {
    const productOptions = card.querySelector(".product-options");
    if (productOptions) {
      const optionContainer = productOptions.querySelector(
        ".product-option-container"
      );
      const overlay = productOptions.querySelector(".product-option-overlay");

      if (optionContainer && overlay) {
        const uniqueId = `${card.dataset.productId}-${card.dataset.mainProductId
          }-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

        optionContainer.dataset.uniqueId = uniqueId;
        overlay.dataset.overlayFor = uniqueId;

        productOptions.dataset.productOptionsFor = uniqueId;
      }
    }
  });
}

async function handleVariantButtonClick(button, event) {
  event.preventDefault();

  if (button.disabled) {
    return;
  }

  let productCard = button.closest(".product-card");

  if (!productCard) {
    const optionContainer = button.closest(".product-option-container");
    if (optionContainer && optionContainer.dataset.originalParent) {
      productCard = document.querySelector(
        `.product-card[data-product-id="${optionContainer.dataset.originalParent}"]`
      );
    }
  }

  if (!productCard) {
    console.error("Could not find product card");
    return;
  }

  let variantId = button.dataset.variantId;
  let price = button.dataset.price;
  let comparePrice = button.dataset.comparePrice;

  if (button.dataset.optionName && button.dataset.optionValue) {
    const activeColorSwatch = productCard.querySelector(".pc-swatch.active");
    const selectedColor = activeColorSwatch?.dataset.color;

    if (selectedColor) {
      if (!productCard._pcProductData) {
        const script = productCard.querySelector(
          'script.pc-product-data[type="application/json"]'
        );
        if (script) {
          try {
            productCard._pcProductData = JSON.parse(script.textContent);
          } catch (e) {
            console.error("Failed to parse product data:", e);
          }
        }
      }

      const product = productCard._pcProductData;
      if (product) {
        const colorIdx = product.options.indexOf("Color");
        const sizeIdx = product.options.indexOf(button.dataset.optionName);

        const variant = product.variants.find(
          (v) =>
            v.options[colorIdx] === selectedColor &&
            v.options[sizeIdx] === button.dataset.optionValue
        );

        if (variant) {
          if (!variant.available) {
            console.error("Selected variant is not available");
            return;
          }
          variantId = variant.id;
          price = variant.price_formatted;
          comparePrice = variant.compare_at_price_formatted;
        }
      }
    }
  }

  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  // Also clear the relocated container's active state — on mobile it lives in #product-options-relocation, outside the card, so a card-only query would miss it.
  const clickedContainer = button.closest(".product-option-container");
  [productCard, clickedContainer].forEach((scope) => {
    if (!scope) return;
    scope
      .querySelectorAll(".product-option-button")
      .forEach((btn) => btn.classList.remove("active"));
  });
  button.classList.add("active");

  productCard.dataset.variantId = variantId;

  closeAllProductOptions();

  // Must scope to this button's ancestor, not just DOM presence — cart-drawer reuses product-card markup and stays mounted over collection pages, so a global check would misfire on drawer clicks.
  const isInCartDrawer = !!button.closest("cart-drawer");
  const isCollectionProducts =
    !isInCartDrawer &&
    !!button.closest('[data-section-type="collection-products"]');
  const isMobile = window.innerWidth <= 768;

  if (!isCollectionProducts) {
    window.dispatchEvent(new CustomEvent("cart:loading"));
    window.dispatchEvent(new CustomEvent("cart:open"));
  }

  const priceElement = productCard.querySelector(".product-price");
  if (priceElement) {
    priceElement.textContent = "";

    if (comparePrice && comparePrice !== "") {
      const currentPriceSpan = document.createElement("span");
      currentPriceSpan.className = "current-price";
      currentPriceSpan.textContent = price;

      const comparePriceSpan = document.createElement("span");
      comparePriceSpan.className = "compared-at-price";
      comparePriceSpan.textContent = comparePrice;

      priceElement.appendChild(currentPriceSpan);
      priceElement.appendChild(comparePriceSpan);
    } else {
      priceElement.textContent = price;
    }
  }

  const addToCartButton = productCard.querySelector(".add-to-cart-button");
  if (addToCartButton) {
    const isDisabled =
      button.disabled || button.classList.contains("disabled");

    if (isDisabled) {
      addToCartButton.disabled = false;
      addToCartButton.removeAttribute("aria-disabled");
      addToCartButton.classList.add("unavailable");
      addToCartButton.textContent = "NOTIFY ME";
    } else {
      addToCartButton.disabled = false;
      addToCartButton.removeAttribute("aria-disabled");
      addToCartButton.classList.remove("unavailable");
      addToCartButton.textContent = "ADD TO CART";
    }
  }

  if (productCard.dataset.atcInFlight === "true") return;
  productCard.dataset.atcInFlight = "true";
  if (addToCartButton && !addToCartButton.disabled) {
    setAtcLoading(addToCartButton);
  }

  try {
    let currentCart = { items: [], item_count: 0 };
    try {
      currentCart = await fetch("/cart.js").then((r) => r.json());
    } catch (err) {
      console.error("Error fetching current cart:", err);
    }

    await updateExistingCartItems(currentCart);

    try {
      const existing = currentCart.items.find(
        (it) =>
          String(it.variant_id) === String(variantId) ||
          String(it.id) === String(variantId)
      );
      const existingQty = existing ? existing.quantity || 0 : 0;
      if (existingQty + 1 > 5) {
        showToast(
          "You can only add up to 5 of this item to your cart.",
          "warning"
        );

        return;
      }
    } catch (err) { }

    const mainItem = { id: variantId, quantity: 1 };
    const itemsToAdd = [mainItem];

    if (window.FREEBIE_CONFIG?.enabled && window.FREEBIE_CONFIG.variantId) {
      const freebieVariantId = Number(window.FREEBIE_CONFIG.variantId);

      const hasFreebie = currentCart.items.some(
        (item) =>
          Number(item.id) === freebieVariantId ||
          Number(item.variant_id) === freebieVariantId
      );

      if (!hasFreebie) {
        const freebieItem = { id: freebieVariantId, quantity: 1 };
        itemsToAdd.push(freebieItem);
      }
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: ["cart-drawer"],
        sections_url: window.location.pathname,
      }),
    });

    if (response.ok) {
      const result = await response.json();

      const productHandle = result.items[0].url || "";

      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      window.dispatchEvent(
        new CustomEvent("cart:count-update", {
          detail: {
            count: cart.item_count,
          },
        })
      );

      window.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart, item: result, sections: result.sections },
        })
      );

      if (isCollectionProducts) {
        const imgSrc =
          result.items?.[0]?.featured_image?.url ||
          result.items?.[0]?.image ||
          null;
        window.dispatchEvent(
          new CustomEvent("cart-tray:open", {
            detail: { image: imgSrc },
          })
        );
      } else {
        window.dispatchEvent(new CustomEvent("cart:open"));
      }
    } else {
      console.error("Failed to add product to cart");

      let errText = "Failed to add to cart";
      try {
        const errJson = await response.json();
        if (errJson && errJson.message) errText = errJson.message;
      } catch (e) { }

      showToast(errText, "error");
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    showToast("Error adding product to cart", "error");
  } finally {
    productCard.dataset.atcInFlight = "";
    if (addToCartButton && !addToCartButton.classList.contains("unavailable")) {
      clearAtcLoading(addToCartButton);
    }
  }
}

function handleSwatchClick(swatch, event) {
  event.preventDefault();

  const productCard = swatch.closest(".product-card");
  if (!productCard) return;

  const selectedColor = swatch.dataset.color;
  if (!selectedColor) return;

  productCard.querySelectorAll(".pc-swatch").forEach((s) => {
    s.classList.remove("active");
  });
  swatch.classList.add("active");

  swapProductCardCarouselColor(productCard, selectedColor);

  let productData = productCard._pcProductData;
  if (!productData) {
    const script = productCard.querySelector(
      'script.pc-product-data[type="application/json"]'
    );
    if (script) {
      try {
        productData = JSON.parse(script.textContent);
        productCard._pcProductData = productData;
      } catch (e) {
        console.error("Failed to parse product data:", e);
      }
    }
  }

  if (productData) {
    const colorIdx = productData.options.indexOf("Color");
    const matchingVariant =
      productData.variants.find(
        (v) => v.options[colorIdx] === selectedColor && v.available
      ) ||
      productData.variants.find(
        (v) => v.options[colorIdx] === selectedColor
      );

    if (matchingVariant) {
      productCard.dataset.variantId = matchingVariant.id;

      const priceElement = productCard.querySelector(".product-price");
      if (priceElement) {
        priceElement.textContent = "";
        if (
          matchingVariant.compare_at_price_formatted &&
          matchingVariant.compare_at_price_formatted !== ""
        ) {
          const currentPriceSpan = document.createElement("span");
          currentPriceSpan.className = "current-price";
          currentPriceSpan.textContent = matchingVariant.price_formatted;
          const comparePriceSpan = document.createElement("span");
          comparePriceSpan.className = "compared-at-price";
          comparePriceSpan.textContent =
            matchingVariant.compare_at_price_formatted;
          priceElement.appendChild(currentPriceSpan);
          priceElement.appendChild(comparePriceSpan);
        } else {
          const currentPriceSpan = document.createElement("span");
          currentPriceSpan.className = "current-price";
          currentPriceSpan.textContent = matchingVariant.price_formatted;
          priceElement.appendChild(currentPriceSpan);
        }
      }

      const addToCartButton = productCard.querySelector(
        ".add-to-cart-button"
      );
      if (addToCartButton) {
        if (!matchingVariant.available) {
          addToCartButton.disabled = false;
          addToCartButton.removeAttribute("aria-disabled");
          addToCartButton.classList.add("unavailable");
          addToCartButton.textContent = "NOTIFY ME";
        } else {
          addToCartButton.disabled = false;
          addToCartButton.removeAttribute("aria-disabled");
          addToCartButton.classList.remove("unavailable");
          addToCartButton.textContent = "ADD TO CART";
        }
      }

      updateDrawerSizesForColor(productCard, productData, selectedColor);
    }
  }
}

async function handleAddToCartClick(button, event) {
  event.preventDefault();

  if (button.classList.contains("unavailable")) {
    const card = button.closest(".product-card");
    const notifyVariantId = card?.dataset.variantId;
    openNotifyMeModal(notifyVariantId ? Number(notifyVariantId) : null);
    return;
  }

  if (button.disabled) return;

  const productCard = button.closest(".product-card");


  if (productCard?.querySelector(".product-option-button")) {
    openProductOptionsDrawer(productCard);
    return;
  }

  const variantId = productCard.dataset.variantId;

  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  // In-flight flag lives on the card, so it survives button re-cloning
  if (productCard.dataset.atcInFlight === "true") return;
  productCard.dataset.atcInFlight = "true";
  setAtcLoading(button);

  try {
    let currentCart = { items: [], item_count: 0 };
    try {
      currentCart = await fetch("/cart.js").then((r) => r.json());
    } catch (err) {
      console.error("Error fetching current cart:", err);
    }

    await updateExistingCartItems(currentCart);

    try {
      const existing = currentCart.items.find(
        (it) =>
          String(it.variant_id) === String(variantId) ||
          String(it.id) === String(variantId)
      );
      const existingQty = existing ? existing.quantity || 0 : 0;
      if (existingQty + 1 > 5) {
        showToast(
          "You can only add up to 5 of this item to your cart.",
          "warning"
        );
        return;
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }

    const mainItem = { id: variantId, quantity: 1 };
    const itemsToAdd = [mainItem];

    if (window.FREEBIE_CONFIG?.enabled && window.FREEBIE_CONFIG.variantId) {
      const freebieVariantId = Number(window.FREEBIE_CONFIG.variantId);

      const hasFreebie = currentCart.items.some(
        (item) =>
          Number(item.id) === freebieVariantId ||
          Number(item.variant_id) === freebieVariantId
      );

      if (!hasFreebie) {
        const freebieItem = { id: freebieVariantId, quantity: 1 };
        itemsToAdd.push(freebieItem);
      }
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: ["cart-drawer"],
        sections_url: window.location.pathname,
      }),
    });

    if (response.ok) {
      const result = await response.json();

      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      window.dispatchEvent(
        new CustomEvent("cart:count-update", {
          detail: {
            count: cart.item_count,
          },
        })
      );

      window.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart, item: result, sections: result.sections },
        })
      );

      closeAllProductOptions();

      document
        .querySelectorAll(".pc-atc-confirmation")
        .forEach((el) => {
          el.style.display = "none";
        });

      const confirmation = productCard.querySelector(
        ".pc-atc-confirmation"
      );
      if (confirmation) {
        confirmation.style.display = "flex";
        clearTimeout(confirmation._hideTimer);
        confirmation._hideTimer = setTimeout(() => {
          confirmation.style.display = "none";
        }, 5000);
      }

    } else {
      throw new Error("Failed to add to cart");
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
  } finally {
    productCard.dataset.atcInFlight = "";
    clearAtcLoading(button);
  }
}

function handleViewCartClick(btn, event) {
  event.preventDefault();
  const confirmation = btn.closest(".pc-atc-confirmation");
  if (confirmation) {
    confirmation.style.display = "none";
  }
  window.dispatchEvent(new CustomEvent("cart:open"));
}

function openNotifyMeModal(variantId = null) {
  const event = new CustomEvent("openNotifyMeModal", {
    detail: { variantId },
  });
  document.dispatchEvent(event);
}

window.initializeProductCards = initializeProductCards;

document.addEventListener("DOMContentLoaded", () => {
  initializeProductCards();
});

let productCardsRefreshTimer = null;
window.addEventListener("cart:updated", () => {
  // Coalesce bursts of rapid cart updates into a single page-wide refresh.
  clearTimeout(productCardsRefreshTimer);
  productCardsRefreshTimer = setTimeout(() => {
    if (typeof initializeProductCards === "function") {
      initializeProductCards();
    }
  }, 300);
});
